module.exports = __webpack_public_path__ + "static/media/Orchids_logo_white.a0ca3c17.png";